 <template lang="pug">
  .crud
    div(v-if="has_permission")
      modal-import(model="quotes" :title="$t('front.import_modal', {model: $t('strings.quotes')})")
      modal-quote-amounts(:newRecord='newRecord')
      modal-assigned(:newRecord='newRecord')
      modal-project(:newRecord='quote', :additional='isModalAdditional' :quote="isModalQuote")
      modal-select-contact(:project_id='project_id', :contacts_flag='contacts_flag', :selected_contacts='selected_contacts')
      .container-fluid
        vm-row.heading(vm-w="12")
          vm-col(vm-type="flex" vm-align="center" vm-lg=6 vm-sm=6)
            .list-title-cont
              .title-c
                h2 {{ $t('strings.quoted') }}
                stage-indicator(color="#4498E0")
              span {{ $t('strings.quoted_description') }}
          vm-col(vm-type="flex" vm-align="center" vm-justify="flex-end" vm-w="6")
            vm-button(icon="eye-outline" @click="cancelled" ) {{ $t('strings.cancelled') }}
            vm-tooltip(:text="$t('strings.options')" delay=".5s")
              vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                vm-button(type="border" icon="more-horizotnal" color="#afbbc6")

                vm-dropdown-menu
                  vm-dropdown-item.d-flex.justify-content-between(@click="printReport")
                    vm-icon(icon="printer-outline")
                    slot &nbsp;{{ $t('strings.print') }}
        vm-tabs(v-model='tap')
          vm-tab(vm-label="Quoting" vm-alignment="fixed")
            vm-row.card(vm-w="12")
              vm-col(vm-sm=12)
                vm-table(multiple v-model="selectedQuoting"  max-height="350px" :data="quoting")
                  template(slot="header")
                    .d-flex.justify-content-between
                      vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filtersQuoting.where.param" @keyup.enter="applyFilterQuoting(filtersQuoting)"  width="300px")
                      div
                        vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                          vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                            vm-button(type="default" icon="funnel-outline" size="small")

                            vm-dropdown-menu(class="filters")
                              .heading.d-flex.justify-content-between
                                h4 {{ $t('strings.filters') }}
                                vm-button(type="flat" size="small" @click="clearFilterQuoting") {{ $t('strings.clear') }}
                              vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filtersQuoting.whereIn.status")
                                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                              vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Additional" v-model="filtersQuoting.whereIn.additional")
                                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in additional")
                              .filter.d-flex
                                vm-button(@click="applyFilterQuoting(filtersQuoting)") {{ $t('strings.apply') }}
                        vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filtersQuoting.orderBy" @change="changeOrderByQuoting(filtersQuoting)" size="small" width="200px" :serializer="item => $t('projects.'+ item)")
                  template(slot="thead")
                    vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
                    vm-th
                  template(slot-scope="{data}")
                    vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                      vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                        slot(v-if="column != 'status' && column != 'amount' && column != 'quotation_created_by' && column != 'quotation_approved' && column != 'additional' && column != 'customer'") {{data[indextr][column]}}
                        slot(v-if="column == 'amount'")  {{data[indextr][column] | currency }}
                        slot(v-if="column == 'quotation_created_by'") {{ data[indextr]['quotation_created']['name'] }}
                        slot(v-if="column == 'customer'") {{ data[indextr]['customer']['name'] }}
                        vm-icon(v-if="column == 'quotation_approved' && data[indextr]['quotation_approved'] == 0" type="flat" icon="clock-outline" color="rgba(var(--gray),1)")
                        vm-icon(v-if="column == 'quotation_approved' && data[indextr]['quotation_approved'] == 1" type="flat" icon="checkmark-circle-2-outline" color="rgb(23, 201, 100)")
                        slot(v-if="column == 'changes_orders'") {{ data[indextr]['additional'] == 1 ? 'SI' : 'NO' }}
                        vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                      vm-td
                        vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                          vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                          vm-dropdown-menu(v-if="data[indextr]['stage'] === 2")
                            vm-dropdown-item.d-flex.justify-content-between(@click="editProject(data[indextr])" v-if="$auth.check('Admin')")
                                vm-icon(icon="edit-2-outline")
                                slot &nbsp;{{ $t('strings.edit') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="revisions_index_permission" @click="addRevision(data[indextr], 0 )")
                              vm-icon(icon="map-outline")
                              slot &nbsp;{{ $t('strings.revisions') }}
                            //- vm-dropdown-item.d-flex.justify-content-between(@click="editQuote(data[indextr], tr, 0)" v-if="project_details_index_permission")
                            //-   vm-icon(icon="list-outline")
                            //-   slot &nbsp;{{ $t('strings.details') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="amount_update_permission" @click="amount(data[indextr], tr)")
                              vm-icon(icon="credit-card-outline")
                              slot(v-if="data[indextr]['amount'] === null") &nbsp;{{ $t('strings.add_amount') }}
                              slot(v-else) &nbsp;{{ $t('strings.edit_amount') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="quotation_files_index_permission" @click="attachment(data[indextr], 0)")
                              vm-icon(icon="file-text-outline")
                              slot &nbsp;{{ $t('strings.quotations') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin') && data[indextr]['quotation_approved'] === 0 && data[indextr]['revisions_quote'] && data[indextr]['revisions_quote'].length > 0 && data[indextr]['amount'] > 0 && data[indextr]['has_quotation_files']" @click="setActionQuote(data[indextr], 'approve')")
                              vm-icon(icon="checkmark-circle-2-outline")
                              slot &nbsp;{{ $t('strings.approve') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="status_store_permission" @click="setActionQuote(data[indextr], 'hold')")
                              vm-icon(icon="clock-outline")
                              slot &nbsp;{{ $t('strings.on_hold') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['quotation_approved'] == 1 && data[indextr]['status'] == 1 && status_store_permission" @click="assigned(data[indextr])")
                              vm-icon(icon="checkmark-square-outline")
                              slot &nbsp;{{ $t('strings.assigned') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['quotation_approved'] == 1 && data[indextr]['status'] == 1 && status_store_permission" @click="setActionQuote(data[indextr], 'no_assigned')")
                              vm-icon(icon="close-square-outline")
                              slot &nbsp;{{ $t('strings.no_assigned') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="status_store_permission" @click="setActionQuote(data[indextr], 'cancelled')")
                              vm-icon(icon="close-outline")
                              slot &nbsp;{{ $t('strings.cancelled') }}
                            vm-dropdown-item.d-flex.justify-content-between(@click="deleteQuoteConfirm(data[indextr])" v-if="$auth.check('Admin')")
                              vm-icon(icon="trash-2-outline")
                              slot &nbsp;{{ $t('strings.delete') }}
                            vm-dropdown-item.d-flex.justify-content-between(@click="selectContact(data[indextr])" v-if="canSelectContacts(data[indextr].customer_id)")
                              vm-icon(icon="people-outline")
                              slot &nbsp;{{ $t('strings.select_contacts') }}

                vm-pagination(:total="pagination_quoting.totalPages" v-model="currentPageQuoting" goto)
                transition(name="enter")
                  .total-records(v-if="total>0") Total: {{ total | currency }}
          vm-tab(vm-label="Quoted" vm-alignment="fixed")
            vm-row.card(vm-w="12")
              vm-col(vm-sm=12)
                vm-table(multiple v-model="selected"  max-height="350px" :data="quotes")
                  template(slot="header")
                    .d-flex.justify-content-between
                      vm-input(ref="search" icon="search" size="small" :placeholder="searchPlaceholder" v-model="filters.where.param" @keyup.enter="applyFilter(filters)"  width="300px")
                      div
                        vm-tooltip(:text="$t('strings.filters')" delay=".5s")
                          vm-dropdown(ref='dropdown' vm-custom-content vm-trigger-click vm-trigger-outside-click)
                            vm-button(type="default" icon="funnel-outline" size="small")

                            vm-dropdown-menu(class="filters")
                              .heading.d-flex.justify-content-between
                                h4 {{ $t('strings.filters') }}
                                vm-button(type="flat" size="small" @click="clearFilter") {{ $t('strings.clear') }}
                              vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Status" v-model="filters.whereIn.status")
                                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in status")
                              vm-select.filter(:placeholder="$t('strings.multiple')" multiple autocomplete label="Additional" v-model="filters.whereIn.additional")
                                vm-select-item(:key="index" :value="item.value" :text="item.text" v-for="(item,index) in additional")
                              .filter.d-flex
                                vm-button(@click="applyFilter(filters)") {{ $t('strings.apply') }}
                        vm-order-by(:sort-by-text="$t('strings.order_by')" placeholder="Ninguno" :data="columnsOrderBy" v-model="filters.orderBy" @change="changeOrderBy(filters)" size="small" width="200px" :serializer="item => $t('projects.'+ item)")
                  template(slot="thead")
                    vm-th(:key="index" v-if="column !== 'id'" v-for="(column, index) in columns") {{ $t('projects.' + column) }}
                    vm-th
                  template(slot-scope="{data}")
                    vm-tr(:data="tr" :key="indextr" v-for="(tr, indextr) in data")
                      vm-td(:data="data[indextr][column]" :key="index" v-if="column !== 'id'" v-for="(column, index) in columns")
                        slot(v-if="column != 'status' && column != 'amount' && column != 'quotation_created_by' && column != 'quotation_approved' && column != 'additional' && column != 'customer'") {{data[indextr][column]}}
                        slot(v-if="column == 'amount'")  {{data[indextr][column] | currency }}
                        slot(v-if="column == 'quotation_created_by'") {{ data[indextr]['quotation_created']['name'] }}
                        slot(v-if="column == 'customer'") {{ data[indextr]['customer']['name'] }}
                        vm-icon(v-if="column == 'quotation_approved' && data[indextr]['quotation_approved'] == 0" type="flat" icon="clock-outline" color="rgba(var(--gray),1)")
                        vm-icon(v-if="column == 'quotation_approved' && data[indextr]['quotation_approved'] == 1" type="flat" icon="checkmark-circle-2-outline" color="rgb(23, 201, 100)")
                        slot(v-if="column == 'changes_orders'") {{ data[indextr]['additional'] == 1 ? 'SI' : 'NO' }}
                        vm-status-indicator(v-if="column == 'status'" :pulse="data[indextr]['status'] !== 'Activo'" :color="colorStatus(data[indextr]['status'])") {{data[indextr]['status_display']}}
                      vm-td
                        vm-dropdown(vm-custom-content vm-trigger-click vm-trigger-outside-click)
                          vm-button(type="flat" icon="more-horizotnal" color="#afbbc6")

                          vm-dropdown-menu(v-if="data[indextr]['stage'] === 2")
                            vm-dropdown-item.d-flex.justify-content-between(@click="editProject(data[indextr])" v-if="$auth.check('Admin')")
                                vm-icon(icon="edit-2-outline")
                                slot &nbsp;{{ $t('strings.edit') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="revisions_index_permission" @click="addRevision(data[indextr], 1)")
                              vm-icon(icon="map-outline")
                              slot &nbsp;{{ $t('strings.revisions') }}
                            //- vm-dropdown-item.d-flex.justify-content-between(@click="editQuote(data[indextr], tr, 1)")
                            //-   vm-icon(icon="list-outline")
                            //-   slot &nbsp;{{ $t('strings.details') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="amount_update_permission" @click="amount(data[indextr], tr)")
                              vm-icon(icon="credit-card-outline")
                              slot(v-if="data[indextr]['amount'] === null") &nbsp;{{ $t('strings.add_amount') }}
                              slot(v-else) &nbsp;{{ $t('strings.edit_amount') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="quotation_files_index_permission" @click="attachment(data[indextr], 1)")
                              vm-icon(icon="file-text-outline")
                              slot &nbsp;{{ $t('strings.quotations') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="$auth.check('Admin') && data[indextr]['quotation_approved'] === 0 && data[indextr]['revisions_quote'] && data[indextr]['revisions_quote'].length > 0 && data[indextr]['amount'] > 0 && data[indextr]['has_quotation_files']" @click="setActionQuote(data[indextr], 'approve')")
                              vm-icon(icon="checkmark-circle-2-outline")
                              slot &nbsp;{{ $t('strings.approve') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="status_store_permission" @click="setActionQuote(data[indextr], 'hold')")
                              vm-icon(icon="clock-outline")
                              slot &nbsp;{{ $t('strings.on_hold') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['quotation_approved'] == 1 && data[indextr]['status'] == 1 && status_store_permission" @click="assigned(data[indextr])")
                              vm-icon(icon="checkmark-square-outline")
                              slot &nbsp;{{ $t('strings.assigned') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="data[indextr]['quotation_approved'] == 1 && data[indextr]['status'] == 1 && status_store_permission" @click="setActionQuote(data[indextr], 'no_assigned')")
                              vm-icon(icon="close-square-outline")
                              slot &nbsp;{{ $t('strings.no_assigned') }}
                            vm-dropdown-item.d-flex.justify-content-between(v-if="status_store_permission" @click="setActionQuote(data[indextr], 'cancelled')")
                              vm-icon(icon="close-outline")
                              slot &nbsp;{{ $t('strings.cancelled') }}
                            vm-dropdown-item.d-flex.justify-content-between(@click="deleteQuoteConfirm(data[indextr])" v-if="$auth.check('Admin')")
                              vm-icon(icon="trash-2-outline")
                              slot &nbsp;{{ $t('strings.delete') }}
                            vm-dropdown-item.d-flex.justify-content-between(@click="selectContact(data[indextr])" v-if="canSelectContacts(data[indextr].customer_id)")
                              vm-icon(icon="people-outline")
                              slot &nbsp;{{ $t('strings.select_contacts') }}

                vm-pagination(:total="pagination.totalPages" v-model="currentPage" goto)
                transition(name="enter")
                  .total-records(v-if="total>0") Total: {{ total | currency }}
    #no-access(v-else)
      access-denied
</template>

<script>
import parseDeleteMany from '@/utils/parseDeleteMany'
import parseVuexObject from '@/utils/parseVuexObject'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotes')

export default {
  name: 'Quotes',
  components: {
    ModalImport: () => import('@/components/modals/ModalImport.vue'),
    ModalQuoteAmounts: () => import('@/components/modals/ModalQuoteAmounts.vue'),
    ModalAssigned: () => import('@/components/modals/ModalAssigned.vue'),
    StageIndicator: () => import('@/components/aditionals/StageIndicator.vue'),
    AccessDenied: () => import('@/components/aditionals/AccessDenied.vue'),
    ModalProject: () => import('@/components/modals/ModalToQuotes.vue'),
    ModalSelectContact: () => import('@/components/modals/ModalSelectContact.vue')
  },
  data: () => ({
    newRecord: {},
    permissions: {},
    quote: {},
    currentPage: 1,
    currentPageQuoting: 1,
    isModalAdditional: true,
    isModalQuote: true,
    selected: [],
    selectedQuoting: [],
    has_permission: true,
    quotation_files_store_permission: true,
    quotation_files_index_permission: true,
    revisions_index_permission: true,
    status_store_permission: true,
    amount_update_permission: true,
    customer_comments_quotation: true,
    customer: true,
    contacts_flag: [],
    selected_contacts: [],
    columns: [
      'project_name',
      'customer',
      'amount',
      'currency_display',
      'location',
      'status',
      'quotation_start_date',
      'quotation_delivery_date',
      'quotation_created_by',
      'comments_quotation',
      'quotation_approved',
      'upload_quotation_date',
      'customer_comments_quotation',
      'changes_orders'
    ],
    columnsOrderBy: [
      'project_name',
      'amount'
    ],
    status: [
      {
        text: 'Pending',
        value: 1,
        color: 'primary'
      },
      {
        text: 'On hold',
        value: 2,
        color: 'warning'
      },
      {
        text: 'Assigned',
        value: 3,
        color: 'success'
      },
      {
        text: 'No assigned',
        value: 4,
        color: 'danger'
      },
      {
        text: 'Canceled',
        value: 5,
        color: 'gray'
      }
    ],
    additional: [
      {
        text: 'NO',
        value: 0
      },
      {
        text: 'SI',
        value: 1
      }
    ],
    filters: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        project_name: '',
        param: ''
      },
      whereIn: {
        status: [],
        additional: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClear: {},
    filtersQuoting: {
      // Nota: Estos campos se parsearan en el v-model de los filtros. Ver linea 60
      where: {
        project_name: '',
        param: ''
      },
      whereIn: {
        status: [],
        additional: []
      },
      whereBetween: {
        // Agrega las columnas que se filtraran entre paramentros ejemplo: priece: []
      },
      betweenDates: {
        // Agrega las columnas que se filtraran entre fechas: created_at: []
      },
      orderBy: ''
    },
    filtersClearQuoting: {}
  }),
  async created () {
    this.checkPermissionView('quoteds.index')
    this.filtersClear = parseVuexObject(this.filters)
    this.filtersClearQuoting = parseVuexObject(this.filtersQuoting)
    if (this.$route.params.customerId) {
      await this.getQuoting(1, this.$route.params.customerId)
      await this.getQuotes(1, this.$route.params.customerId)
    } else {
      await this.getQuoting(1)
      await this.getQuotes(1)
    }
    await this.loadQuotesCatalog()
  },
  methods: {
    ...mapActions([
      'loadQuotes',
      'loadCatalog',
      'loadQuotesCatalog',
      'actionQuote',
      'deleteQuote',
      'setModalImportVisible',
      'setModalAmountVisible',
      'setModalAssignedVisible',
      'setModalProjectVisible',
      'setModalContactVisible',
      'printReport',
      'applyFilter',
      'clearFilter',
      'applyFilterQuoting',
      'clearFilterQuoting',
      'loadQuoting',
      'loadEmployees',
      'setTap'
    ]),
    changeOrderBy (data) {
      if (data.orderBy) {
        let [field, order] = data.orderBy.split(',')
        if (order === 'dsc') {
          order = 'desc'
        }
        data.orderBy = `${field},${order}`
      }
      this.applyFilter(data)
    },
    changeOrderByQuoting (data) {
      if (data.orderBy) {
        let [field, order] = data.orderBy.split(',')
        if (order === 'dsc') {
          order = 'desc'
        }
        data.orderBy = `${field},${order}`
      }
      this.applyFilterQuoting(data)
    },
    checkPermissionView (permission) {
      this.has_permission = this.$auth.user().view_permissions.findIndex(e => e.name === permission) > -1
      this.quotation_files_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'quotation_files.store') > -1
      this.quotation_files_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'quotation_files.index') > -1
      this.revisions_index_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'revisions.index') > -1
      this.status_store_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'status.store') > -1
      this.amount_update_permission = this.$auth.user().view_permissions.findIndex(e => e.name === 'amount.update') > -1
      this.customer_comments_quotation = this.$auth.user().view_permissions.findIndex(e => e.name === 'customer_comments_quotation.store') > -1
      this.customer = this.$auth.user().view_roles.findIndex(e => e === 'Customer') > -1
    },
    cancelled () {
      this.$router.push({ name: 'cancelled' })
    },
    attachment (quote, tap) {
      this.setTap(tap)
      this.$router.push(`/quotation-files/${quote.id}`)
    },
    assigned (quote) {
      this.newRecord = { ...quote }
      this.newRecord.approve_shop_drawings_weeks = 0
      this.newRecord.structure_weeks = 0
      this.newRecord.joist_weeks = 0
      this.newRecord.detailing_weeks = 0
      this.setModalAssignedVisible(true)
    },
    canSelectContacts (id) {
      if (this.customer) {
        return this.customer.id === id
      }
      return true
    },
    colorStatus (code) {
      return this.status.find(e => e.value === parseInt(code))['color']
    },
    setFocusSearch () {
      this.$refs.search.$refs.vminput.focus()
    },
    editShortcut () {
      if (this.selected.length === 0 || this.selected.length > 1) return
      const idx = this.quotes.findIndex(u => u.id === this.selected[0].id)
      this.editQuote(this.selected[0], idx)
    },
    addRevision (quote, tap) {
      this.setTap(tap)
      this.$router.push(`/revisions/${quote.id}`)
    },
    amount (quote, index) {
      quote.amount ? (this.newRecord = { ...quote }) : (this.newRecord = { currency: 1, id: quote.id })
      this.setModalAmountVisible(true)
    },
    editQuote (quote, index, tap) {
      let id = quote.id
      this.setTap(tap)
      this.$router.push({ name: 'AddDetails', params: { id, isAdd: true } })
    },
    editProject (record) {
      this.isModalAdditional = false
      this.isModalQuote = true
      this.quote = { ...record }
      this.setModalProjectVisible(true)
    },
    async selectContact (quote) {
      this.project_id = quote.id
      this.contacts_flag = []
      this.selected_contacts = []
      let set1 = []
      let t = this
      await this.loadEmployees({ employer: quote.customer_id })
      setTimeout(() => {
        if (t.employees.length) {
          set1 = new Set(t.employees.map(e => e.id))
          t.contacts_flag = quote.contacts.map(e => !!set1.has(e.id))
          t.selected_contacts = quote.contacts.map(e => e.id)
          t.setModalContactVisible(true)
        } else {
          t.$vm.dialog({
            color: 'primary',
            title: t.$t('projects.contact'),
            text: 'No employees found'
          })
        }
      }, 1000)
    },
    async deleteQuoteConfirm (quote) {
      let t = this
      this.auxDeleteQuote = () => {
        t.deleteQuote(quote).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quote'), attribute: this.$t(quote.id) }),
        accept: this.auxDeleteQuote
      })
    },
    async deleteQuotesConfirm () {
      let t = this
      let quotesMany = parseDeleteMany(this.selected, 'id')
      this.auxDeleteQuote = () => {
        t.deleteQuotes(quotesMany).then(() => { t.selected = [] })
      }
      this.$vm.dialog({
        color: 'danger',
        title: this.$t('front.delete_modal'),
        text: this.$t('front.delete_confirmation', { model: this.$t('strings.quote'), attribute: quotesMany.values }),
        accept: this.auxDeleteQuote
      })
    },
    async setActionQuote (record, action) {
      record.id && this.actionQuote({ id: record.id, action })
    },
    async getQuotes (page, customerId) {
      this.loadQuotes({ page: page, customer: customerId })
    },
    async getQuoting (page, customerId) {
      this.loadQuoting({ page: page, customer: customerId })
    },
    autoCompleteFunc (value, url) {
      this.loadCatalog({ filter: value, url: url })
    },
    hiddeDrop () {
      let [dropdownMenu] = this.$refs.dropdown.$children.filter((item) => {
        return item.hasOwnProperty('dropdownVisible')
      })
      dropdownMenu.dropdownVisible = false
    }
  },
  computed: {
    ...mapGetters([
      'quotes',
      'pagination',
      'filterParams',
      'quoting',
      'pagination_quoting',
      'filterParamsQuoting',
      'tap',
      'employees'
    ]),
    searchPlaceholder () {
      let t = this
      let concatColumns = Object.keys(this.filters.where).reduce((str, column, index) => {
        if (column !== 'param' && index < Object.keys(t.filters.where).length - 2) return (index > 0) ? `${str}, $\{t.$t('quotes.' + column)}` : `${str} ${t.$t('quotes.' + column)}`
        return str
      }, '')
      return this.$t('strings.search', { attribute: this.$t('strings.quoted'), columns: concatColumns, column: this.$t('projects.' + Object.keys(this.filters.where)[Object.keys(t.filters.where).length - 2]) })
    },
    enabledDelete () {
      return this.selected.length > 0
    },
    total () {
      return this.selected.reduce((prev, cur) => prev + parseFloat(cur.total), 0).toFixed(2)
    }
  },
  watch: {
    currentPage (currentPage) {
      this.getQuotes(currentPage)
    },
    currentPageQuoting (currentPage) {
      this.getQuoting(currentPage)
    },
    filterParams (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filters = parseVuexObject(this.filtersClear))
      this.selected = []
      this.currentPage = 1
      this.getQuotes(this.currentPage)
    },
    filterParamsQuoting (filter) {
      this.hiddeDrop()
      filter.length === 0 && (this.filtersQuoting = parseVuexObject(this.filtersClearQuoting))
      this.selectedQuoting = []
      this.currentPageQuoting = 1
      this.getQuoting(this.currentPageQuoting)
    }
  }
}
</script>

<style lang="scss">
.filters {
  .filter {
    padding: 5px 10px;
    width: 250px;
  }
}
.con-vm-tooltip {
  display: inline-block;
  position: relative;
}
.vm-table--header {
  padding: 10px;
  span:nth-child(1)  {
    width: 100%;
  }
  .input-select-con{
    span {
      width: auto !important;
    }
  }
  .justify-content-between {
    div:last-child {
      .vm-button {
        margin: 0 3px;
      }
      .vm-con-dropdown {
        float: left;
      }
      .con-select {
        display: inline-block;
        input {
          height: 32px;
        }
      }
    }
  }
}
.list-title-cont {
  display: flex;
  flex-direction: column;
  .title-c {
    display: flex;
    align-items: center;
  }
}
</style>
